<template>
  <div v-if="activeLocation && activeLocation.status === 'active'">
        <base-header class="header pb-7 pt-md-4 pb-5 pt-3 pt-md-8 d-flex align-items-center"
                     style="background-size: cover; background-position: center top;">
            <!-- Mask -->
            <span class="mask bg-gradient-info opacity-8"></span>
            <!-- Header container -->
            <div v-if="$store.getters['authentication/isService']" class="pb-3">
              <ProfileArea v-if="activeLocation.isActivityAllowed || activeLocation.isProtocolAllowed || activeLocation.isInspectionTourAllowed"/>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0" v-if="$store.getters['authentication/isService'] && typeof activeLocation.socialconcept !== 'undefined'">
                    <activity v-if="activeLocation.isActivityAllowed" :socialconcept="activeLocation.socialconcept['@id']" ref="activity"></activity>
                    <base-button v-if="activeLocation.playerCheckAllowed && activeLocation.isProtocolAllowed" v-on:click="$router.push('/service/protocols/create')" class="mb-2" block type="secondary" size="lg" icon="fab fa-wpforms text-blue">neues Protokoll</base-button>
                    <tasks v-if="activeLocation.isTaskAllowed"></tasks>
                    <Kontrollgang v-if="activeLocation.isInspectionTourAllowed" />
                </div>
                <div :class="($store.getters['authentication/isService'] && typeof activeLocation.socialconcept !== 'undefined') ? 'col-xl-8 order-xl-1' : 'col'">

                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
  <div class="p-8" v-else>
    <p class="alert alert-danger text-center my-4 py-3 fw-bold">
      Dieser Standort ist inaktiv oder wurde gekündigt!
    </p>
  </div>
</template>
<script>

    import Kontrollgang from "@/views/ServiceDashboard/Kontrollgang";
    import ProfileArea from "@/views/ServiceDashboard/ProfileArea.vue";
    import Activity from "@/views/ServiceDashboard/Activity";
    import Tasks from "@/views/ServiceDashboard/Tasks";

    export default {
    name: 'user-profile',
      components: {Tasks, Activity, ProfileArea, Kontrollgang},
      data() {
      return {
        model: {
          data: '',
        }
      }
    },
        created() {
            this.$store.dispatch('userLocations/getUserLocations').then(items =>  {
                if (items['hydra:member'].length > 1 && this.$store.getters['authentication/isService']) {
                    this.$store.dispatch('config/change',{customer: false, location: true})
                }
            })
        },
        computed: {
            activeLocation() {
                return (this.$store.getters['location/isReady']) ? this.$store.getters['location/showLocationByIRI']('/api/locations/'+this.$store.getters['authentication/location']) : 'loading';
            }
        }
  };
</script>
